import { Component } from '@angular/core';
import { ToastsManager } from 'ng2-toastr';
import { ViewContainerRef } from '@angular/core';
import { APPCONFIG } from '../config';
import {CsvService} from "angular2-json2csv"
@Component({
  selector: 'my-app-layout',
  template: require('./layout.component.html'),
  providers:[CsvService]
})
export class LayoutComponent {

	logedin = false;

	constructor(public toastr: ToastsManager, vcr: ViewContainerRef){
		this.toastr.setRootViewContainerRef(vcr);
		let lg = this.getIsLoggedIn();
		if(lg && lg == 'true'){
			this.logedin = true;
		}else{
			this.logedin = false;
		}
	}

	getIsLoggedIn(){
		return localStorage.getItem(APPCONFIG.prefix+"isLoggedIn");
	}

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/layout/layout.component.ts